import React from 'react';
import DashboardContext from './DashboardContext';
import SubContext from '../subs/SubContext';
import { API } from '../API';
import PropTypes from 'prop-types';

const DashboardContainer = ({ children }) => {
  const subCtx = React.useContext(SubContext);
  const [dashboards, setDashboards] = React.useState([]);
  const [selectedDashboard, setSelectedDashboard] = React.useState(null);
  const [selectedSubscriberKey, setSubscriberKey] = React.useState(null);

  React.useEffect(() => {
    if (subCtx.selectedSub) {
      API.get(
        '/get?subscriber=' + subCtx.selectedSub //+ '?user_access=' + subCtx.userRole
      )
        .then((res) => {
          setDashboards(res.data.charts);

          //if (!(selectedDashboard && res.data.charts.map(d => d.dashboard).includes(selectedDashboard))) {
            //setSelectedDashboard(null);
          //}

          if (res.data.charts.length === 1) {
            setSelectedDashboard(res.data.charts[0].dashboard);
          }
          setSubscriberKey(res.data.subscriberKey);
        })
        .catch((err) => console.log(err));
    }
  }, [subCtx.selectedSub]);

  return (
    <DashboardContext.Provider
      value={{ dashboards, selectedDashboard, setSelectedDashboard, selectedSubscriberKey }}
    >
      {children}
    </DashboardContext.Provider>
  );
};

DashboardContainer.propTypes = {
  children: PropTypes.any,
};

export default DashboardContainer;
